import React from 'react';
import { Box, Typography } from '@mui/material';
import MotivoLogo from '../Header/MotivoLogo';

export interface MoLogoWithTextProps {
  text: string;
  width?: number | string;
  logoColor?: string;
}

export function MoLogoWithText({ text, width = '100%', logoColor }: MoLogoWithTextProps) {
  return (
    <Box>
      <MotivoLogo width={width} color={logoColor} />
      <Typography mt={-2.2} fontWeight={600} textAlign="right" color="text.primary">
        {text}
      </Typography>
    </Box>
  );
}
